import React from "react";

interface FormRangeProps {
    id: string,
    title: string,
    min: number,
    max: number,
    step: number,
    value: number,
    sign?: string,
    textPosition?: "bottom" | "right"
    changeValue: (value:number) => void
    onEndAcion?: () => void
}
 

class FormRange extends React.Component<FormRangeProps> {
    constructor(props:FormRangeProps){
        super(props)

    }

    onChange(event:React.ChangeEvent<HTMLInputElement>){
        let currentValue = Number(event.target.value);
        this.props.changeValue(currentValue)
    }

    render() { 
        const {sign = "%", textPosition = "bottom"} = this.props
        const percentage = Math.round(((this.props.value - this.props.min) / (this.props.max - this.props.min)) * 100);
        return (
            <>
                <label htmlFor={this.props.id}> {this.props.title}</label>
                <div className={`range-wrapper ${textPosition === "right" ? "right-text" : ""}`}>
                    <div className="">
                    <input 
                        id={this.props.id}
                        className="range-control" 
                        type="range" 
                        min={this.props.min} 
                        max={this.props.max} 
                        step={this.props.step} 
                        value={this.props.value}
                        onChange={(event)=>{this.onChange(event)}}
                        onMouseUp={this.props.onEndAcion}
                    />
                    <div className="progress" style={{"width": `${percentage}%`}}></div>
                    </div>
                    <span>{this.props.value}{sign}</span>
                </div>
                
            </>
        );
    }
}
 
export default FormRange;